<template>
    <div>          <div class="banner">
     <div class="slg"> <p class="slg_title1">新闻中心</p>
       <p class="slg_title2">诚信为基共筑未来 贴心服务助力企业发展</p></div>
      <div class="section-banner"></div>

   </div>
<div>

  <div class="article">
            <p class="title">关于我司与北京建功京和电子系统工程有限公司的合作公告</p>
            <br>
            <p class="message"><span>时间：2025-05-22 17:54</span><!--<span>来源：青海新闻网</span>--><span>浏览次数：1343</span>
            </p>
            <div class="article_line"></div>
            <div class="arti_con">
<!--                <img src="../../assets/img/news/gjgs1.png">-->
                <p>为进一步推动数据服务领域的创新发展，提升金融服务效能，我司与北京建功京和电子系统工程有限公司、北京建功京和电子系统工程有限公司长治分公司经友好协商，于[2025 年 3 月 25 日]正式达成战略合作协议。此次合作将充分发挥双方在技术研发和服务方面的优势，共同打造高效、安全的服务体系。
                </p>
<p>1，合作主要内容如下：</p>
              <p>2，我司授权北京建功京和电子系统工程有限公司、北京建功京和电子系统工程有限公司长治分公司使用其数据信息查询系统，并提供以下运维服务：</p>
              <p>(1)信用数据信息查询服务</p>
                 <p>(2)数据报告生成服务</p>
                 <p>(3)其他约定服务</p>
              <p>3，我司委托北京建功京和电子系统工程有限公司、北京建功京和电子系统工程有限公司长治分公司负责提供软件技术开发支持及更新维护</p>
              <p>4，市场推广与合作双方将共同开展市场推广活动，包括：</p>
              <p>
                (1)联合品牌宣传与广告推广</p>
<p>(2)行业解决方案的联合开发
              </p>
              <p>此次合作期限为[3 年]，自[2025 年 3 月 25 日]起生效。合作期间，双方将严格遵守国家相关法律法规，确保数据安全与用户隐私保护。</p>
              <p>我司将持续优化服务质量，与北京建功京和电子系统工程有限公司、北京建功京和电子系统工程有限公司长治分公司携手，为客户提供更优质、更高效的服务体验。</p>
         <div style="width: 300px;float: right">           <p>特此公告。</p>
              <p>2025年3月25日</p></div>

            </div>
        </div>
</div></div>
</template>

<script>
export default {
  name: 'news2024101703'
}
</script>

<style scoped>
.article {
    width: 90%;
    min-height: 800px;
    padding-top: 30px;
    padding-bottom: 30px;
    margin: auto;
}
  .article .title {
    border: none;
    font-size: 24px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #1267aa;
    line-height: 45px;
}
  .article .article_line {
    width: 100%;
    height: 2px;
    background: #ccc;
    margin: 20px auto;
}
  .article .title, .message, .article_line {
    text-align: center;
}
  .message, .article_line {
    text-align: center;
}
  .article p span {
    margin-right: 60px;
}
  .article .arti_con img {
    display: block;
    max-width: 50%;
    margin: 20px auto;
}
  .news-main{
    width: 1250px;
    margin: auto;
  }
      .banner {
    background-image: url(../../assets/img/bg1.jpg);
    background-size: cover;
    background-position: center;
    height: 560px;
    overflow: hidden;
}
      .slg{
    width: 1200px;
    margin: auto;
    padding-top: 200px;
  }
    .slg_title1{
    font-size: 50px;
    color: #d46700;
    margin: 0px 0px 0px 0px;
  }
    .slg_title2{
      margin: 20px 0px 0px 0px;
    font-size: 40px;
    color: #ffffff;
          position: relative;
    z-index: 10;
  }

</style>



// WEBPACK FOOTER //
// src/view/news/news2025052201.vue